import { createFileRoute } from '@tanstack/react-router';

import { AdminPromocodesPage } from '@pages/admin';

export const Route = createFileRoute(
  '/$locale/_authenticated/admin/settings/business/communications-promotions/promocodes'
)({ component: AdminPromocodes });

function AdminPromocodes() {
  return <AdminPromocodesPage />;
}
